import { render, staticRenderFns } from "./TravellerDetail.vue?vue&type=template&id=07fc0448&"
import script from "./TravellerDetail.vue?vue&type=script&lang=js&"
export * from "./TravellerDetail.vue?vue&type=script&lang=js&"
import style0 from "./TravellerDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports